module.exports = __webpack_public_path__ + "img/gallery-8.afbbbf4b.jpg";